module.exports = __webpack_public_path__ + "static/media/content-play-icon.db2c01cd.png";